import WithRender from "../../templates/containers/pageOptionContainer.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getActiveProductPageOptions",
      "getSummaryPageOptionActive"
    ]),
    getSummaryIndex: function () {
      const options = this.getActiveProductPageOptions;
      return Object.keys(options).length + 1;
    },
    getSummaryActive: function () {
      return this.getSummaryPageOptionActive ? "active" : "";
    }
  },
  methods: {
    ...mapActions(["setSummaryPageOptionActive", "setActivePageOption"]),
    onClickSelectSummary() {
      this.setSummaryPageOptionActive(true);
      this.setActivePageOption();
    }
  },
  props: ["hideContainer"]
});
